import { store } from "@/store/store";
import { Usuario } from "@/shared/dtos/usuario";
import {
  VuexModule,
  Mutation,
  getModule,
  Module,
  Action,
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { changepwd } from "@/shared/dtos/changepwd";
import { UsuarioAllDto } from "@/shared/dtos/usuariosAllDto";
import { ssmPermissionService } from "@/shared/services/PermissionService";

@Module({
  namespaced: true,
  name: "usuarioModule",
  store,
  dynamic: true,
})
class usuarioModule extends VuexModule {
  public usuarios: UsuarioAllDto[] = [];
  public usuario: Usuario = new Usuario();
  public mi_usuario: Usuario = new Usuario();

  @Action({ commit: "onGetusuarios" })
  public async getusuarios() {
    return await ssmHttpService.get(API.usuario);
  }
  @Action({ commit: "onGetusuariosPermiso" })
  public async getusuariosPermiso() {
    return await ssmHttpService.get(API.usuario + "/permisos/");
  }

  @Action({ commit: "onGetusuarios" })
  public async getusuariosActivos() {
    return await ssmHttpService.get(API.usuario + "/activos/");
  }

  @Action({ commit: "onGetusuario" })
  public async getusuario(id: any) {
    return await ssmHttpService.get(API.usuario + "/" + id);
  }

  @Action({ commit: "onGetusuario" })
  public async getusuario_plataforma(id: any) {
    return await ssmHttpService.get(API.usuario + "/user_platform/" + id);
  }

  @Action({})
  public async getusuario_pwd(id: any) {
    return await ssmHttpService.get(API.usuario + "/user_pwd/" + id);
  }

  @Action({ commit: "onGetmi_usuario" })
  public async getmiusuario() {
    return await ssmHttpService.get(API.usuario + "/mi_user/");
  }

  @Action
  public async guardarusuario(usuario: Usuario) {
    /*toJson() no existe pero existe en la extends de BaseDto*/
    return await ssmHttpService.post(API.usuario, usuario.toJson());
  }

  @Action
  public async modificarusuario(usuario: Usuario) {
    return await ssmHttpService.put(API.usuario + "/" + usuario.id, usuario);
  }
  @Action
  public async modificarmi_usuario(usuario: Usuario) {
    return await ssmHttpService.put(
      API.usuario + "/mi_user",
      usuario,
      true,
      false,
      true
    );
  }

  @Action
  public async change_pwdusuario(change: changepwd) {
    /*toJson() no existe pero existe en la extends de BaseDto*/
    await ssmHttpService.post(
      API.usuario + "/change_pwd/",
      change.toJson(),
      true,
      false,
      true
    );
  }

  @Action
  public async sudochange_pwdusuario(change: changepwd) {
    /*toJson() no existe pero existe en la extends de BaseDto*/
    await ssmHttpService.post(
      API.usuario + "/sudo_change_pwd/",
      change.toJson(),
      true,
      false,
      true
    );
  }

  @Action
  public async asignar_centro(payload: { id: number; id_centro: number | null }) {
    return await ssmHttpService.put(
      API.usuario + "/asignar_centro/" + payload.id,
      { id_centro: payload.id_centro }
    );
  }

  @Action
  public async eliminarusuario(usuario: Usuario) {
    await ssmHttpService.delete(API.usuario + "/" + usuario.id, null, false);
    await this.context.dispatch("getusuarios");
  }

  @Mutation
  public onGetusuarios(res: Usuario[]) {
    this.usuarios = res ? res.map((x) => new UsuarioAllDto(x)) : [];
  }

  @Mutation
  public onGetusuariosPermiso(res: string[]) {
    ssmPermissionService.setPermissions(res);
  }

  @Mutation
  public onGetusuario(res: Usuario) {
    this.usuario = new Usuario(res);
    this.usuario.ids_datos_empresa = res.ids_datos_empresa ? res.ids_datos_empresa.map((x) => x) : [];
  }

  @Mutation
  public onGetmi_usuario(res: Usuario) {
    this.mi_usuario = new Usuario(res);
  }

}
export default getModule(usuarioModule);
